import { render, staticRenderFns } from "./ProductoSucursalFiltroMarca.vue?vue&type=template&id=401570f4&scoped=true&"
import script from "./ProductoSucursalFiltroMarca.vue?vue&type=script&lang=js&"
export * from "./ProductoSucursalFiltroMarca.vue?vue&type=script&lang=js&"
import style0 from "./ProductoSucursalFiltroMarca.vue?vue&type=style&index=0&id=401570f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401570f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VChip,VMenu})
